export enum AtomChannels {
  Podlet = 'advertising-podlet'
}

export enum AtomTopics {
  PlacementsMap = 'placementsMap',
  PPID = 'ppid',
  Glimr = 'glimr',
  Cycle = 'cycle',
  GamTargeting = 'gamTargeting',
  PrebidLoadedList = 'prebidLoadedList',
  Config = 'config',
  Afs = 'afs',
  PlacementStatusMetrics = 'placementStatusMetrics',
  UnleashFeatures = 'unleashFeatures',
  SearchFilters = 'searchFilters',
  InitialState = 'initialState',
  WaitForClient = 'waitForClient',
  PlacementMetricSequence = 'placementMetricSequence',
  AdStatusSequence = 'adStatusSequence',
  SignificantEvents = 'significantEvents',
  Consent = 'consent',
  AmplitudeExperiments = 'amplitudeExperiments',
  PrebidTargeting = 'prebidTargeting',
  PageViewId = 'pageViewId',
  RetailMedia = 'retailmedia'
}
